import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bg text-white">
      <Header />
      <main className="flex-1 fade-in">{children}</main>
      <Footer />
    </div>
  );
}
